// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Drawer } from '../../../drawer';
import { LangDrawerContainer } from './style';
import { warningIconBase64 } from '../../../../assets/base64/warning-icon';
import { useTranslation } from 'react-i18next';
export const LangDrawerComponent = ({ isOpen, onClose, language, setLanguage, }) => {
    const [selectedLang, setSelectedLang] = useState(language);
    const { t } = useTranslation('drawerChangeLangue');
    useEffect(() => {
        setSelectedLang(language);
    }, [isOpen]);
    const InputRadio = ({ value, label }) => {
        return (React.createElement("div", { className: `drawer-lang_radio ${value === selectedLang ? 'checked' : ''}` },
            React.createElement("label", { htmlFor: value },
                React.createElement("input", { type: "radio", name: "language", id: value, value: value, checked: value === selectedLang, onChange: (event) => setSelectedLang(event.target.value) }),
                label)));
    };
    return ReactDOM.createPortal(React.createElement(Drawer, { isOpen: isOpen, onClose: onClose, title: t('drawerChangeLangue:title'), cancelButton: {
            text: t('drawerChangeLangue:btnCancel'),
        }, confirmButton: {
            text: t('drawerChangeLangue:btnConfirm'),
            onClick: () => setLanguage(selectedLang),
            disabled: language === selectedLang,
        } },
        React.createElement(LangDrawerContainer, null,
            React.createElement("p", { className: "drawer-lang_description" }, t('drawerChangeLangue:description')),
            React.createElement("section", { className: "drawer-lang_body" },
                React.createElement(InputRadio, { value: "pt-BR", label: "Portugu\u00EAs (BR)" }),
                React.createElement(InputRadio, { value: "es-ES", label: "Espa\u00F1ol" }),
                React.createElement(InputRadio, { value: "en-US", label: "English" })),
            selectedLang !== 'pt-BR' && (React.createElement("section", { className: "drawer-lang_footer" },
                React.createElement("img", { alt: "Warning", title: "Warning", src: warningIconBase64 }),
                React.createElement("div", null,
                    React.createElement("p", { className: "drawer-lang_footer-title" }, t('drawerChangeLangue:alertTitle')),
                    React.createElement("p", null, t('drawerChangeLangue:alertDescription'))))))), document.getElementById('root-app_side_content'));
};
//# sourceMappingURL=component.js.map